module.exports = __webpack_public_path__ + "img/circle-stop.9b4fd936.svg";